export enum userTypeEnum {
  ADM_NAT = 'Administrateur national',
  ADM_MET = 'Administrateur métier',
  ADM_LOC = 'Administrateur local',
  DEL_TEC = 'Delegue technique',
  AGT = 'Agent',
}
